if(document.querySelector(".webien-scroll-sequence")) {

    // Settings
    const bucketPath = 'meetevoko.com/wp-content/uploads/webien/scroll-sequence';
    const desktopFolder = '7';
    const desktopPrefix = 'shot03_1440_';
    const mobileFolder = '6';
    const mobilePrefix = 'shot03_768_';
    const frameCount = 241;


    gsap.registerPlugin(ScrollTrigger);

    let sections = gsap.utils.toArray(".webien-scroll-sequence");

    sections.forEach(section => {
        let canvas = section.querySelector(".scroll-canvas");
        canvas ? initCanvas(section, canvas) : initOther(section);
    });

    function initCanvas(section, canvas) {

        let context = canvas.getContext("2d");
        canvas.width = 767;
        canvas.height = 640;


        let folder = mobileFolder;
        let prefix = mobilePrefix;
        let quality = 80;
        let pinOffset = 112;

        if (window.innerWidth >= 768) {
            folder = desktopFolder;
            prefix = desktopPrefix;
            quality = 96;
            pinOffset = 144;


            canvas.width = 1440;
            canvas.height = 640;

            section.style['aspect-ratio'] = 1440 + ' / ' + 640;
        }

        const currentFrame = index => (
            getImageUrl(index, folder, prefix, quality)
        );

        let images = []
        let sequence = {
            frame: 0
        };

        for (let i = 0; i < frameCount; i++) {
            let img = new Image();
            img.src = currentFrame(i);
            images.push(img);
        }


        ScrollTrigger.create({
            trigger: section,
            start: () => "top " + pinOffset + 'px',
            pin: true,
            end: "+=100%",
        });

        window.mainTimeline = gsap.timeline({
            onUpdate: render,
            scrollTrigger: {
                trigger: section,
                start: () => "top center",
                scrub: 0.5,
                end: "+=150%",
                markers: false,
                anticipatePin: 1
            }
        })
            .to(sequence, {
                frame: frameCount - 1,
                snap: "frame",
                ease: "none",
                duration: 1
            }, 0);

        images[0].onload = render;

        function render() {
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.drawImage(images[sequence.frame], 0, 0);
        }
    }

    function getImageUrl(index, folder, imagePrefix, quality) {
        let url = '';

        let resizeDistribution = window.webienImages.imageDistribution + '/';
        let path = bucketPath + `/${folder}/${imagePrefix}${(index).toString().padStart(3, '0')}.png`;

        // Build json object
        let obj = {};
        obj.imageUrl = 'https://' + path;
        obj.publicKey = window.webienImages.publicKey;
        //obj.bucket = window.webienImages.awsBucket;
        //obj.key = path;
        obj.edits = {};
        //obj.edits.avif = {};
        //obj.edits.avif.quality = 100;
        //obj.edits.avif.speed = 8; // 0 (slowest/smallest), 8 (fastest/largest)
        obj.edits.webp = {};
        obj.edits.webp.quality = quality;
        obj.edits.toFormat = 'webp';


        return resizeDistribution + btoa(unescape(encodeURIComponent(JSON.stringify(obj))));
    }

    function initOther(section) {
        ScrollTrigger.create({
            trigger: section,
            pin: true,
            end: "+=150%"
        });
    }
}